import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

export const VendorRequestStatus = {
  NEW: 'New',
  REQUESTED: 'Requested',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  CANCELLED: 'Cancelled',
};

export const VENDOR_REQUEST_STATUS_LABEL_VARIANT = {
  [VendorRequestStatus.NEW]: LabelVariant.ORANGE,
  [VendorRequestStatus.REQUESTED]: LabelVariant.BLUE,
  [VendorRequestStatus.COMPLETED]: LabelVariant.GREEN,
  [VendorRequestStatus.FAILED]: LabelVariant.RED,
  // A withdrawn order is neutral, not an error — grey keeps it distinct from Failed (red) and Completed (green).
  [VendorRequestStatus.CANCELLED]: LabelVariant.GRAY,
};

const TERMINAL_STATUSES = [
  VendorRequestStatus.COMPLETED,
  VendorRequestStatus.FAILED,
  VendorRequestStatus.CANCELLED,
];

export const isTerminalVendorRequestStatus = status => TERMINAL_STATUSES.includes(status);

// The coloured statuses read as pills from their saturated fill alone; the neutral GRAY of a withdrawal has a
// shade-2 fill that matches the table surface, so it needs a border to still read as a pill (light mode).
const BORDERED_STATUSES = [VendorRequestStatus.CANCELLED];

export const isBorderedVendorRequestStatus = status => BORDERED_STATUSES.includes(status);
